import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  id: {
    // Navigation
    nav: {
      home: 'Beranda',
      products: 'Produk',
      industry: 'Industri',
      caseStudy: 'Case Study',
      about: 'Tentang Kami',
      contactUs: 'Hubungi Kami',
    },
    // Home page
    home: {
      heroSubtitle: 'Partner Resmi XGRIDS di Indonesia',
      heroTitle1: 'Teknologi 3D Scanning',
      heroTitle2: 'Masa Depan',
      heroDesc: 'XGRIDS Indonesia adalah distributor resmi perangkat 3D scanning dan spatial computing dari XGRIDS. Kami menyediakan solusi terdepan untuk survei, konstruksi, dan industri kreatif.',
      viewProducts: 'Lihat Produk',
      featuredProducts: 'Produk Unggulan',
      featuredProductsSubtitle: 'Perangkat 3D Scanning Terdepan',
      featuredProductsDesc: 'Kami fokus mendistribusikan PortalCam dan Lixel L2 Pro - dua produk andalan XGRIDS untuk pasar Indonesia.',
      industryApps: 'Aplikasi Industri',
      industryAppsSubtitle: 'Solusi untuk Berbagai Sektor',
      learnMore: 'Pelajari Lebih Lanjut',
      caseStudyTitle: 'Solusi Teruji di Lapangan',
      viewAllCaseStudies: 'Lihat Semua Case Study',
      ctaTitle: 'Siap Mengadopsi Teknologi 3D?',
      ctaDesc: 'Konsultasikan kebutuhan Anda dengan tim ahli kami. Kami akan membantu memilih solusi terbaik untuk bisnis Anda.',
      scheduleConsultation: 'Jadwalkan Konsultasi',
    },
    // Products page
    products: {
      catalog: 'Katalog Produk',
      title: 'Perangkat 3D Scanning Premium',
      desc: 'XGRIDS Indonesia menyediakan rangkaian produk lengkap dari XGRIDS serta perangkat pendukung untuk solusi geospasial dan 3D scanning Anda.',
      featured: 'Produk Unggulan',
      featuredDesc: 'Scanner 3D pilihan utama kami dengan dukungan penuh di Indonesia',
      allXgrids: 'Semua Produk XGRIDS',
      allXgridsDesc: 'Rangkaian lengkap hardware, software, dan plugin dari XGRIDS',
      supporting: 'Supporting Products',
      supportingDesc: 'Perangkat pendukung untuk melengkapi solusi geospasial Anda',
      priceFrom: 'Harga',
      contactUs: 'Hubungi Kami',
      requestQuote: 'Minta Penawaran',
      brochure: 'Katalog',
      specs: 'Spesifikasi',
      needHelp: 'Butuh Bantuan Memilih Produk?',
      needHelpDesc: 'Tim ahli kami siap membantu Anda memilih solusi yang tepat sesuai kebutuhan proyek. Konsultasi gratis!',
      visitXgrids: 'Kunjungi XGRIDS Global',
    },
    // Industry page
    industry: {
      coverage: 'Cakupan Industri',
      title: 'Solusi untuk Setiap Sektor',
      desc: 'Teknologi 3D scanning XGRIDS telah terbukti di berbagai industri, dari survei geospasial hingga produksi film. Temukan bagaimana solusi kami dapat membantu bisnis Anda.',
      notFound: 'Tidak Menemukan Industri Anda?',
      notFoundDesc: 'Teknologi kami fleksibel untuk berbagai kebutuhan. Konsultasikan use case spesifik Anda dengan tim kami.',
      freeConsultation: 'Konsultasi Gratis',
      surveyGeo: 'Survei & Geospasial',
      surveyGeoDesc: 'Solusi lengkap untuk pemetaan dan pengukuran dengan akurasi tinggi',
      aec: 'AEC & Perencanaan Urban',
      aecDesc: 'Dokumentasi as-built dan integrasi BIM untuk konstruksi modern',
      film: 'Film & Hiburan',
      filmDesc: 'Capture dunia nyata untuk produksi konten visual berkualitas tinggi',
      energy: 'Energi & Pertambangan',
      energyDesc: 'Digital twin dan monitoring untuk operasi industrial',
    },
    // Case Study page
    caseStudy: {
      title: 'Solusi Teruji di Lapangan',
      desc: 'Lihat bagaimana teknologi XGRIDS telah membantu berbagai proyek di seluruh dunia mencapai hasil yang luar biasa.',
      allIndustries: 'Semua Industri',
      noData: 'Belum ada case study untuk kategori ini.',
      similarProject: 'Punya Proyek Serupa?',
      similarProjectDesc: 'Mari diskusikan bagaimana teknologi XGRIDS dapat membantu proyek Anda mencapai hasil terbaik.',
      consultProject: 'Konsultasi Proyek',
    },
    // About page
    about: {
      title: 'XGRIDS Indonesia',
      subtitle: 'Tentang Kami',
      desc1: 'Kami adalah partner resmi XGRIDS di Indonesia, berkomitmen untuk membawa teknologi 3D scanning dan spatial computing terdepan ke pasar lokal.',
      desc2: 'Dengan fokus pada PortalCam dan Lixel L2 Pro, kami menyediakan solusi end-to-end mulai dari konsultasi, penjualan, hingga dukungan teknis pasca-penjualan untuk memastikan kesuksesan implementasi di proyek Anda.',
      officialPartner: 'Partner Resmi',
      features: {
        partner: 'Partner Resmi',
        partnerDesc: 'Distributor resmi dan terpercaya dari XGRIDS untuk wilayah Indonesia',
        support: 'Support Teknis',
        supportDesc: 'Tim ahli lokal siap membantu instalasi, training, dan troubleshooting',
        consultation: 'Konsultasi Gratis',
        consultationDesc: 'Analisis kebutuhan dan rekomendasi solusi tanpa biaya',
      },
      whyXgrids: 'Mengapa XGRIDS',
      whyXgridsTitle: 'Teknologi Terdepan untuk Hasil Terbaik',
      whyPoints: [
        'Akurasi millimeter dengan teknologi LiDAR + SLAM',
        'Real-time processing untuk produktivitas maksimal',
        'Integrasi seamless dengan workflow CAD/BIM',
        'Support global dengan kehadiran lokal',
        '2000+ customer di seluruh dunia',
      ],
      stats: {
        customers: 'Pelanggan Global',
        patents: 'Paten Teknologi',
        rdTeam: 'Tim R&D',
        accuracy: 'Akurasi',
      },
      contact: {
        title: 'Hubungi Kami',
        subtitle: 'Mari Diskusikan Kebutuhan Anda',
        desc: 'Tim kami siap membantu Anda memilih solusi terbaik untuk proyek Anda. Hubungi kami untuk konsultasi gratis.',
        officeAddress: 'Alamat Kantor',
        email: 'Email',
        phone: 'Telepon',
        form: {
          name: 'Nama Lengkap',
          email: 'Email',
          phone: 'Telepon',
          company: 'Perusahaan',
          message: 'Pesan',
          messagePlaceholder: 'Ceritakan kebutuhan Anda...',
          submit: 'Kirim Pesan',
          sending: 'Mengirim...',
          success: 'Pesan berhasil dikirim! Kami akan segera menghubungi Anda.',
          error: 'Gagal mengirim pesan. Silakan coba lagi.',
        },
      },
    },
    // Footer
    footer: {
      desc: 'Partner Resmi XGRIDS di Indonesia. Distributor teknologi 3D scanning dan spatial computing terdepan.',
      products: 'Produk',
      allProducts: 'Semua Produk XGRIDS',
      industries: 'Industri',
      contact: 'Kontak',
      admin: 'Admin',
      global: 'XGRIDS Global',
      rights: 'All rights reserved.',
    },
    // Common
    common: {
      loading: 'Memuat...',
      contactUs: 'Hubungi Kami',
      learnMore: 'Pelajari Lebih Lanjut',
      viewDetails: 'Detail Produk',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      products: 'Products',
      industry: 'Industry',
      caseStudy: 'Case Study',
      about: 'About Us',
      contactUs: 'Contact Us',
    },
    // Home page
    home: {
      heroSubtitle: 'Official XGRIDS Partner in Indonesia',
      heroTitle1: '3D Scanning Technology',
      heroTitle2: 'of the Future',
      heroDesc: 'XGRIDS Indonesia is the official distributor of 3D scanning and spatial computing devices from XGRIDS. We provide cutting-edge solutions for surveying, construction, and creative industries.',
      viewProducts: 'View Products',
      featuredProducts: 'Featured Products',
      featuredProductsSubtitle: 'Leading 3D Scanning Devices',
      featuredProductsDesc: 'We focus on distributing PortalCam and Lixel L2 Pro - two flagship XGRIDS products for the Indonesian market.',
      industryApps: 'Industry Applications',
      industryAppsSubtitle: 'Solutions for Various Sectors',
      learnMore: 'Learn More',
      caseStudyTitle: 'Field-Proven Solutions',
      viewAllCaseStudies: 'View All Case Studies',
      ctaTitle: 'Ready to Adopt 3D Technology?',
      ctaDesc: 'Consult with our expert team. We will help you choose the best solution for your business.',
      scheduleConsultation: 'Schedule Consultation',
    },
    // Products page
    products: {
      catalog: 'Product Catalog',
      title: 'Premium 3D Scanning Devices',
      desc: 'XGRIDS Indonesia provides a complete range of products from XGRIDS and supporting devices for your geospatial and 3D scanning solutions.',
      featured: 'Featured Products',
      featuredDesc: 'Our top choice 3D scanners with full support in Indonesia',
      allXgrids: 'All XGRIDS Products',
      allXgridsDesc: 'Complete range of hardware, software, and plugins from XGRIDS',
      supporting: 'Supporting Products',
      supportingDesc: 'Supporting devices to complement your geospatial solutions',
      priceFrom: 'Price',
      contactUs: 'Contact Us',
      requestQuote: 'Request Quote',
      brochure: 'Brochure',
      specs: 'Specifications',
      needHelp: 'Need Help Choosing a Product?',
      needHelpDesc: 'Our expert team is ready to help you choose the right solution for your project needs. Free consultation!',
      visitXgrids: 'Visit XGRIDS Global',
    },
    // Industry page
    industry: {
      coverage: 'Industry Coverage',
      title: 'Solutions for Every Sector',
      desc: 'XGRIDS 3D scanning technology has been proven across various industries, from geospatial surveying to film production. Discover how our solutions can help your business.',
      notFound: "Can't Find Your Industry?",
      notFoundDesc: 'Our technology is flexible for various needs. Consult your specific use case with our team.',
      freeConsultation: 'Free Consultation',
      surveyGeo: 'Surveying & Geospatial',
      surveyGeoDesc: 'Complete solutions for mapping and measurement with high accuracy',
      aec: 'AEC & Urban Planning',
      aecDesc: 'As-built documentation and BIM integration for modern construction',
      film: 'Film & Entertainment',
      filmDesc: 'Capture the real world for high-quality visual content production',
      energy: 'Energy & Mining',
      energyDesc: 'Digital twin and monitoring for industrial operations',
    },
    // Case Study page
    caseStudy: {
      title: 'Field-Proven Solutions',
      desc: 'See how XGRIDS technology has helped various projects around the world achieve outstanding results.',
      allIndustries: 'All Industries',
      noData: 'No case studies available for this category.',
      similarProject: 'Have a Similar Project?',
      similarProjectDesc: "Let's discuss how XGRIDS technology can help your project achieve the best results.",
      consultProject: 'Project Consultation',
    },
    // About page
    about: {
      title: 'XGRIDS Indonesia',
      subtitle: 'About Us',
      desc1: 'We are the official partner of XGRIDS in Indonesia, committed to bringing cutting-edge 3D scanning and spatial computing technology to the local market.',
      desc2: 'With a focus on PortalCam and Lixel L2 Pro, we provide end-to-end solutions from consultation, sales, to post-sales technical support to ensure successful implementation in your projects.',
      officialPartner: 'Official Partner',
      features: {
        partner: 'Official Partner',
        partnerDesc: 'Official and trusted distributor of XGRIDS for Indonesia region',
        support: 'Technical Support',
        supportDesc: 'Local expert team ready to help with installation, training, and troubleshooting',
        consultation: 'Free Consultation',
        consultationDesc: 'Needs analysis and solution recommendations at no cost',
      },
      whyXgrids: 'Why XGRIDS',
      whyXgridsTitle: 'Leading Technology for Best Results',
      whyPoints: [
        'Millimeter accuracy with LiDAR + SLAM technology',
        'Real-time processing for maximum productivity',
        'Seamless integration with CAD/BIM workflow',
        'Global support with local presence',
        '2000+ customers worldwide',
      ],
      stats: {
        customers: 'Global Customers',
        patents: 'Technology Patents',
        rdTeam: 'R&D Team',
        accuracy: 'Accuracy',
      },
      contact: {
        title: 'Contact Us',
        subtitle: "Let's Discuss Your Needs",
        desc: 'Our team is ready to help you choose the best solution for your project. Contact us for a free consultation.',
        officeAddress: 'Office Address',
        email: 'Email',
        phone: 'Phone',
        form: {
          name: 'Full Name',
          email: 'Email',
          phone: 'Phone',
          company: 'Company',
          message: 'Message',
          messagePlaceholder: 'Tell us about your needs...',
          submit: 'Send Message',
          sending: 'Sending...',
          success: 'Message sent successfully! We will contact you soon.',
          error: 'Failed to send message. Please try again.',
        },
      },
    },
    // Footer
    footer: {
      desc: 'Official XGRIDS Partner in Indonesia. Leading 3D scanning and spatial computing technology distributor.',
      products: 'Products',
      allProducts: 'All XGRIDS Products',
      industries: 'Industries',
      contact: 'Contact',
      admin: 'Admin',
      global: 'XGRIDS Global',
      rights: 'All rights reserved.',
    },
    // Common
    common: {
      loading: 'Loading...',
      contactUs: 'Contact Us',
      learnMore: 'Learn More',
      viewDetails: 'Product Details',
    },
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('xgrids_lang') || 'id';
  });

  useEffect(() => {
    localStorage.setItem('xgrids_lang', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'id' ? 'en' : 'id');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
